import React from 'react';
import GlobalHelper from '../../Helpers/GlobalHelper';

const MontoMask = (props) => {

    function mostrarInformacion() {
        let moneda = "";
        switch (props.moneda) {
            case "pesos":
                moneda = "$";
                break;
            case "dolares":
                moneda = "U$S";
                break;
        }

        let monto = props.monto;

        if (props.monto != null || props.monto){
            monto = monto.toString().replace("(", "");
            monto = monto.toString().replace(")", "");
        }

        let montoConvertido = GlobalHelper.CompletarDecimales(monto);

        let value = (monto == 0 || monto == null || !monto) ? "0.00" :
            monto > 0 ? moneda + " " + montoConvertido :
                "(" + moneda + " " + montoConvertido.toString().replace("-", "") + " )";

        return value;
    }

    return (
        <label className={ props.class == undefined ? "label-primary " : props.class }>{mostrarInformacion()}</label>
    );
}

export default MontoMask;